import { render, staticRenderFns } from "./RegionalCooperation.vue?vue&type=template&id=7700286e&scoped=true"
import script from "./RegionalCooperation.vue?vue&type=script&lang=js"
export * from "./RegionalCooperation.vue?vue&type=script&lang=js"
import style0 from "./RegionalCooperation.vue?vue&type=style&index=0&id=7700286e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7700286e",
  null
  
)

export default component.exports